import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { MembershipService } from 'app/core/services/membership.service';
import { NexusFormResultModel } from 'app/models/nexus-form-result.model';
import { QuestionnaireModel, QuestionnaireStatus, QuestionnaireTemplateModel, QuestionnaireValidationResult } from 'app/models/questionnaire.model';
import { SessionModel } from 'app/models/session.model';
import { TokenPropertyModel } from 'app/models/token-property.model';
import { QuestionnaireService } from 'app/services/questionnaire.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { faFileDownload, faFileUpload, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { StepType } from '@progress/kendo-angular-layout/stepper/types';
import { AuditHistoryService } from 'app/core/services/audit-history.service';
import { AuditSearchModel } from 'app/models/audit.model';
@Component({
  selector: 'app-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.scss']
})
export class QuestionnaireComponent  extends NexusComponent implements OnDestroy {

   public audit_search: AuditSearchModel;

  faFileDownload = faFileDownload;
  faFileUpload = faFileUpload;
  public questionnaire_model: QuestionnaireModel = new QuestionnaireModel();
  public is_save_enabled : boolean;
  public session: SessionModel = null;
  private dialogRef: DialogRef;
  public form = new UntypedFormGroup({
    questionnaire_template_id: this.CreateFormControl(),
    status: this.CreateFormControl(),
    additional_note : this.CreateFormControl()
  });
  public questionnaire_template_models : Array<QuestionnaireTemplateModel>;
  public form_result: NexusFormResultModel = new NexusFormResultModel();
  public validation_result: Array<QuestionnaireValidationResult> = [];
  public validation_dialog_result: NexusFormResultModel = new NexusFormResultModel();
  public faInfoCircle = faInfoCircle;
  public restrictions: FileRestrictions = {
    allowedExtensions: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'xlsm', 'xlsb', 'png', 'gif', 'jpg', 'jpeg', 'txt', 'csv', 'tiff', 'tif', 'mp3', 'mpeg', 'mpg', 'wav', 'ppt', 'pptm', 'pptx','svg','zip']
    };
  public form_upload = new UntypedFormGroup({
    file_id: this.CreateRequiredFormControl()
  });
  public DIALOGS = {
    file_upload_dialog : false,
    error_dialog : false
  }
  public UPLOAD_STATUS = [
    "Approved", "Declined","Pending"
  ];

  public file_update_title: string;
  public current_file_upload: any;
  public questionnaire_form: UntypedFormGroup;
  public questionnaire_form_panels = [];
  public update_basic_information: boolean = false;
  public view_enabled: boolean = false;
  public is_editmode: boolean = true;
  private property_change_subscription: Subscription;
  public stepType: StepType = "label";
  public current_status = 0;

  public steps = [
    { label: "Incomplete", q_status:"incomplete", isValid: true ,disabled: false,icon: "k-icon k-font-icon k-i-check-circle"},
    { label: "Pending Approval", q_status:"pending-approval",isValid: true,disabled: false},
    { label: "Approved", q_status:"approved",isValid: true,disabled: true}
  ];
  public status_mapping = {
    "Incomplete" : 0,
    "PendingApproval" : 1,
    "Approved": 3
  };

  constructor(protected route: ActivatedRoute,private fb: FormBuilder,private questionnaire_service: QuestionnaireService,private dialog_service: DialogService,private membership: MembershipService,private router: Router,private audit_service: AuditHistoryService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.validation_dialog_result.Incomplete();
    this.questionnaire_service.GetQuestionnaireTemplates().pipe(take(1)).subscribe(data => {
      this.questionnaire_template_models = data;
     });

    this.membership.GetSession().pipe(take(1)).subscribe(
      data => {
          this.session = data;
          if(this.session?.current_property?.id!=null){
            const questionnaire_id = this.route.snapshot.paramMap.get('questionnaire_id');
            this.load_questionnaire(this.session?.current_property?.id,questionnaire_id);
          }
      },
      error => {
          this.session = null;
      });

    this.property_change_subscription= this.membership.current_property$.subscribe((model: TokenPropertyModel)=>{
      if(model?.id!=null){
        const questionnaire_id = this.route.snapshot.paramMap.get('questionnaire_id');
        this.load_questionnaire(model?.id,questionnaire_id);


      }
    });

  }

  load_questionnaire(property_id: string,questionnaire_id: string){
    this.StartSpinner('app-questionnaire');
    this.audit_search = {
      object_type : "property-questionnaire",
      object_reference : questionnaire_id,
      audit_sources: ["Client Portal"]
    };
    this.questionnaire_service.GetQuestionnaire(property_id,questionnaire_id).pipe(take(1)).subscribe(
      data => {
        this.questionnaire_model = data;
        this.StopSpinner('app-questionnaire');
        this.update_current_status();
        if(this.questionnaire_model.questionnaire_response){
          this.load_questionnaire_template(this.questionnaire_model.questionnaire_response);
        }
      },
      err => {
        this.StopSpinner('app-questionnaire');
        this.router.navigate(['/dashboard']);
      });
  }

  get is_read_only(): boolean{
   return this.questionnaire_model?.status == "Approved";
  }
  get is_completed(): boolean{
    return this.questionnaire_model?.status == "Complete";
   }

   get is_incomplete(): boolean{
    return this.questionnaire_model?.status == "Incomplete";
   }


   update_current_status(){
    this.current_status =this.status_mapping[this.questionnaire_model?.status] || 0;
    const completed_icon ='k-icon k-font-icon k-i-check-circle';
    const steps = [];
    for(let i =0; i<= this.steps.length -1;i++){
      const is_completed = this.current_status > i;
      const is_progress = this.current_status == i;
      if(is_completed){
        steps.push({
          label : this.steps[i].label == 'Incomplete'? 'Complete' : this.steps[i].label,
          q_status : this.steps[i].q_status,
          isValid :true,
          icon : completed_icon
        });
      } else if(is_progress){
        steps.push({
          label : this.steps[i].label,
          q_status : this.steps[i].q_status,
          isValid :true,
          is_progress : true
        });
      } else{
        steps.push({
          label : this.steps[i].label,
          q_status : this.steps[i].q_status,
          isValid :true,
          disabled : true
        });
      }

    }
    this.steps =steps;

   }

  submit(status: string = QuestionnaireStatus.INCOMPLETE) {
    this.form_result.Reset();
    this.SetFormTouched(this.form);
    if (this.form.invalid) {
      this.form_result.Incomplete();
      return;
    }



      if(status!= QuestionnaireStatus.INCOMPLETE){
        this.validation_result = this.validate_response(this.questionnaire_form.value);
        if(this.validation_result.length >0){
          //show error dialog
          this.open_dialog('error_dialog');
          return;
        }
      }

      this.questionnaire_model.questionnaire_response =this.convert_form_question_response(this.questionnaire_form.value);


    this.questionnaire_model.status = status;
    this.StartSpinner();
    this.questionnaire_service.SaveQuestionnaire(this.questionnaire_model).subscribe(
      data => {
        this.questionnaire_model = data;
        this.form_result.Success();
        this.StopSpinner();
        this.router.navigate(['/questionnaires']);
      },
      error => {
        this.form_result.Error(error);
        this.StopSpinner();
      });


  }
  load_questionnaire_template(template_json: string){
    const template = JSON.parse(template_json);
    const group = {};
    for (const panel of template) {
      for (const field of panel.fields) {
        if(field.type=="date"){
          group[field.id] = field.value ? new FormControl(new Date(field.value)) : new FormControl();
        } else if(field.type=="table"){
          const table_fields = field.fields;
          const row_count = field.repeat;
          for (const table_field of table_fields) {
            const values =table_field.values || [];
            for(let i=0; i<row_count;i++ ){
              group[table_field.id+ '_' + i] = new FormControl(values?.[i]);
            }
          }

        } else if(field.type=="file_upload"){
          field.fields.forEach(file_upload_field => {
            group[file_upload_field.id] = new FormControl(file_upload_field.value || null);
          });
        }else{
          group[field.id] = new FormControl(field.value || '');
        }

      }
      this.questionnaire_form_panels.push(panel);
    }
    this.questionnaire_form = this.fb.group(group);
  }

  convert_form_question_response(form_value: any): any{
    const response = this.questionnaire_model.questionnaire_response;

    if(response && form_value){
      const template = JSON.parse(response);
      for (const panel of template) {
        for (const field of panel.fields) {
          if(field.type=="date" && form_value[field.id]){
            field["value"] = form_value[field.id]?.toString();
          } else if(field.type=="table"){
            const table_fields = field.fields;
            const row_count = field.repeat;
            for (const table_field of table_fields) {
              const values =[];
              for(let i=0; i<row_count;i++ ){
                if(form_value[table_field.id + '_' + i]){
                  values.push(form_value[table_field.id + '_' + i])
                } else{
                  values.push('');
                }

              }
              table_field["values"] = values;
            }
          }else if(field.type=="file_upload"){
            for (const table_field of field.fields) {
              table_field["value"] = form_value[table_field.id]
            }
          }else{
            field["value"] = form_value[field.id];
          }

        }
      }
      return JSON.stringify(template);
    }

    return null;
  }

  validate_response(form_value: any): Array<QuestionnaireValidationResult>{
    const response = this.questionnaire_model.questionnaire_response;
    const result:Array<QuestionnaireValidationResult>=[];
    if(response && form_value){
      const template = JSON.parse(response);
      for (const panel of template) {
        for (const field of panel.fields) {
          if(field.type=="file_upload"){

            for (const file_upload_field of field.fields) {
              const value = form_value[file_upload_field.id];
              if(file_upload_field.required=="true" && (value== null || value==undefined || value=='')){
                result.push({section_name: panel.section_name,label: file_upload_field.label});
              }
            }

          } else{
            const value = form_value[field.id];
            if(field.required=="true" && (value== null || value==undefined || value=='')){
              result.push({section_name: panel.section_name,label: field.label});
            }
          }

        }
      }
    }

    return result;
  }
  public open_dialog(dialog_type: string,arg: any = null) {
    if(dialog_type == "file_upload_dialog" && arg.label){
      this.file_update_title = `${arg.label} - File Upload`;
      this.current_file_upload =arg;
      this.form_upload.get('file_id').setValue(null);
    }
    this.DIALOGS[dialog_type] = true;
  }

  public close_dialog(dialog_type: string) {
    if(dialog_type == "file_upload_dialog"){
      this.file_update_title = `File Upload`;
    }
    this.DIALOGS[dialog_type] = false;
  }

  public file_upload_submit(file_input: any){
    if(file_input?.staged_files?.length>0){
      this.current_file_upload.value = file_input.staged_files[0];
      this.current_file_upload.value.status ="Pending";
    } else{
      this.current_file_upload.value = null;
    }
    this.questionnaire_form.get(this.current_file_upload.id).setValue(this.current_file_upload.value);
    this.close_dialog("file_upload_dialog");
  }


  public file_upload_cancel(file_input: any){

    this.close_dialog("file_upload_dialog");
  }
public file_upload_clear(arg: any){
  if(arg){
    arg.value = null;
    this.questionnaire_form.get(arg.id).setValue(null);
  }

}

    download_file(template_download: any){

      if(template_download?.id && template_download?.name){
        const a: HTMLAnchorElement = document.createElement("a") as HTMLAnchorElement;

        a.href =  `download-file/${template_download.id}/name/${template_download?.name}`;
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();

        setTimeout(function() {
          document.body.removeChild(a);
        }, 100);

      }

      }

      update_notes(arg: any,event: any) {
        const notes = event.target?.value || '';
        const current_value = this.questionnaire_form.get(arg.id)?.value || { notes: null};
        current_value.notes =notes;
        this.questionnaire_form.get(arg.id).setValue(current_value);
      }

      ngOnDestroy() {
        if (this.property_change_subscription) {
          this.property_change_subscription.unsubscribe();
        }
      }
}
